module.exports = __webpack_public_path__ + "5608c0ed5fb09b00bc5b22344e02aead.svg";